import login from './auth/login.json';
import getUser from './auth/get_user.json';

export type MockResponse = {
  status?: number;
  data: any;
};

const routes: Record<string, MockResponse | (() => MockResponse)> = {
  'POST /admin/onboarding/login': { data: login },
  'GET admin/onboarding': { data: getUser },
  'GET /admin/onboarding': { data: getUser },
};

const normalizeKey = (method: string, url: string) => {
  const m = method.toUpperCase();
  const u = url.replace(/^https?:\/\/[^/]+/, '');
  return `${m} ${u}`;
};

export const mockRequest = async (
  method: string,
  url: string,
  body?: any
): Promise<MockResponse> => {
  const key = normalizeKey(method, url);
  const entry = routes[key];
  if (!entry) {
    return { status: 200, data: {} };
  }
  const res = typeof entry === 'function' ? entry() : entry;
  return { status: res.status ?? 200, data: res.data };
};
